import React, { useState } from 'react';
import axios from 'axios';

const useEditorMessage = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([]);

    const getEditorMessageData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/editormessage')
        .then((response) => {
            // console.log('response', response)
            let data = response.data
            setData(data?.data)
            if (data) {
                onFinish(
                    {
                        axiosMode: "get",
                        status: "success"
                    }
                )
            }
            else {
                onFinish(
                    {
                        axiosMode: "get",
                        status: "error"
                    }
                )
            }

            return {
                ...data
            }
        })
    }
    const postEditorMessageData = (data) => {
        onBefore({ 
            axiosMode: "post" 
        })
        axios.post('/editormessage',
            data
        )
        .then((response) => {
            let responseData = response.data
            let status = responseData?.status
            if (status === "fail") {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            }
            else {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "success"
                    }
                )
            }
        })
        .catch(() => {
            onFinish(
                {
                    axiosMode: "post",
                    status: "error"
                }
            )
        })
    }
    const patchEditorMessageData = (data) => {
        onBefore({ 
            axiosMode: "patch" 
        });
        axios.patch('/editormessage',
            data
    )
        .then((response) => {
            let responseData = response.data
            let status = responseData?.status
            if (status === "fail") {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            }
            else {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "success"
                    }
                )
            }
        })
        .catch(() => {
            onFinish(
                {
                    axiosMode: "patch",
                    status: "error"
                }
            )
        })
    }
    const deleteEditorMessageData = (data) => {
        onBefore({ 
            axiosMode: "delete" 
        })
        axios.delete('/editormessage',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        EditorMessageData: data,
        getEditorMessageData,
        postEditorMessageData,
        patchEditorMessageData,
        deleteEditorMessageData,
    }
}
export { useEditorMessage };